module.exports = __webpack_public_path__ + "static/media/collaboration.8c01bbdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/collaboration.png
// module id = 885
// module chunks = 0